import axios from './instance';

// Fetch all discussions
export const getDiscussions = async () => {
  try {
    const res = await axios.get('http://localhost:8000/api/discussions');
    return res.data;
  } catch (error) {
    console.error("Error fetching discussions:", error);
    throw error;
  }
};

// Fetch a single discussion by ID
export const getDiscussionById = async (discussionID) => {
  try {
    const res = await axios.get(`http://localhost:8000/api/discussions/${discussionID}`);
    return res.data;
  } catch (error) {
    console.error(`Error fetching discussion with ID ${discussionID}:`, error);
    throw error;
  }
};

// Create a new discussion
export const createDiscussion = async (discussionData) => {
  try {
    const res = await axios.post('http://localhost:8000/api/discussions', discussionData);
    return res.data;
  } catch (error) {
    console.error("Error creating discussion:", error);
    throw error;
  }
};

// Update an existing discussion
export const updateDiscussion = async (discussionID, discussionData) => {
  try {
    const res = await axios.patch(`http://localhost:8000/api/discussions/${discussionID}`, discussionData);
    return res.data;
  } catch (error) {
    console.error(`Error updating discussion with ID ${discussionID}:`, error);
    throw error;
  }
};

// Delete a discussion by ID
export const deleteDiscussion = async (discussionID) => {
  try {
    const res = await axios.delete(`http://localhost:8000/api/discussions/${discussionID}`);
    return res.data;
  } catch (error) {
    console.error(`Error deleting discussion with ID ${discussionID}:`, error);
    throw error;
  }
};

// Add a like to a discussion
export const addLikeToDiscussion = async (discussionID, userId) => {
  try {
    const res = await axios.patch(`http://localhost:8000/api/discussions/${discussionID}/like`, { userId });
    return res.data;
  } catch (error) {
    console.error(`Error liking discussion with ID ${discussionID}:`, error);
    throw error;
  }
};
